import React from "react";
import { Box, Button, SimpleGrid, Text, VStack, useColorModeValue } from "@chakra-ui/react";
import { FaCheckCircle, FaFileImage, FaFilePdf, FaLinkedin } from "react-icons/fa";

interface ActionsCardProps {
  onDownload: () => void;
  onDownloadPdf: () => void;
  onLinkedIn: () => void;
  onVerify: () => void;
  isDownloadLoading: boolean;
  isPdfLoading: boolean;
  isDisabled: boolean;
  isIdCard: boolean;
}

export const ActionsCard: React.FC<ActionsCardProps> = ({
  onDownload,
  onDownloadPdf,
  onLinkedIn,
  onVerify,
  isDownloadLoading,
  isPdfLoading,
  isDisabled,
  isIdCard,
}) => {
  const cardBg = useColorModeValue("white", "gray.700");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const labelColor = useColorModeValue("gray.500", "gray.400");

  return (
    <Box bg={cardBg} borderWidth={1} borderColor={borderColor} rounded="xl" shadow="sm" p={{ base: 4, md: 5 }} w="100%">
      <VStack spacing={5} align="stretch">
        <Button
          w="100%"
          h="48px"
          colorScheme="red"
          leftIcon={<FaCheckCircle />}
          onClick={onVerify}
        >
          Verify Certificate
        </Button>

        <Box>
          <Text fontSize="xs" fontWeight="semibold" color={labelColor} textTransform="uppercase" letterSpacing="wide" mb={2}>
            Download
          </Text>
          <SimpleGrid columns={2} spacing={3}>
            <Button
              variant="outline"
              leftIcon={<FaFileImage />}
              onClick={onDownload}
              isLoading={isDownloadLoading}
              isDisabled={isDisabled}
            >
              Image
            </Button>
            <Button
              variant="outline"
              leftIcon={<FaFilePdf />}
              onClick={onDownloadPdf}
              isLoading={isPdfLoading}
              isDisabled={isDisabled}
            >
              PDF
            </Button>
          </SimpleGrid>
        </Box>

        {!isIdCard && (
          <Button w="100%" colorScheme="linkedin" leftIcon={<FaLinkedin />} onClick={onLinkedIn}>
            Add to LinkedIn
          </Button>
        )}
      </VStack>
    </Box>
  );
};
